import { jsx as _jsx } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import styles from './analyticsSidenavSection.module.scss';
export const AnalyticsSidenavSection = ({ children, section, hidden = false, }) => {
    const sectionClassName = classNames(styles.section, {
        [styles.sectionHidden]: hidden,
    });
    return (_jsx(FlexBox, Object.assign({ className: sectionClassName, flexDirection: "column", role: "menu", "aria-hidden": hidden, "aria-label": section.title }, { children: children })));
};
